var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.document)?_c('div',{staticClass:"yeti-article"},[_c('sub-panel-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('markdown-section',{attrs:{"document":_vm.document,"field":_vm.fields.description,"hide-title":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }